// @flow
import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";

import { StyledTabs } from "imagus-components";
import { AdminList } from "../../global/containers/NavList";

class Navbar extends Component<*> {
  constructor(props) {
    super(props);
  }

  render(): * {
    let tabs = [];
    AdminList.map((nav: { [key: string]: * }, i: number) => {
      tabs.push({ label: nav.text, to: nav.to });
    });
    return (
      <StyledTabs
        tabs={tabs}
        router={this.props.location.pathname}
        linkComponent={Link}
      />
    );
  }
}

export default withRouter(Navbar);
